export default {
  print: {
    BASE_COMPONENT: '基础组件',
    customText: '自定义文案',
    customImage: '自定义图片',
    blankLine: '空行',
    customQrCode: '自定义二维码',
    customBarCode: '自定义条形码',

    SHOP_INFO: '门店信息',
    shopName: '门店名称',
    shopPhone: '门店电话',
    shopAddress: '门店地址',
    brandName: '品牌名称',

    ORDER_INFO: '订单信息',
    orderId: '订单号',
    serialNo: '流水号',
    orderTime: '下单时间',
    payTime: '支付时间',
    payMethod: '支付方式',
    orderType: '订单类型',
    orderSource: '订单来源',
    tableNo: '桌台号',
    ticketNo: '取餐号',
    remark: '整单备注',

    CUSTOMER_INFO: '顾客信息',
    customerName: '顾客昵称',
    memberLevel: '会员等级',
    memberPhone: '手机号',

    OPERATOR_INFO: '操作者信息',
    cashierName: '收银员',
    operationTerminal: '操作终端',
    operatorNo: '操作员工号',

    GOODS_INFO: '商品信息',
    goodsName: '商品名称',
    goodsSpec: '商品规格',
    goodsPrice: '商品单价',
    goodsQty: '商品数量',
    goodsAmount: '商品金额',

    AMOUNT_INFO: '金额信息',
    receivableAmount: '应收金额',
    discountTotal: '优惠金额',
    actualAmount: '实收金额',
    changeAmount: '找零金额',

    printer: {
      addDevice: '新增打印设备',
      editDevice: '编辑打印设备',
      printDevice: '打印设备',
      printDeviceName: '打印设备名称',
      deviceName: '设备名称',
      terminalNo: '终端号',
      belongStore: '归属门店',
      storeName: '门店名称',
      bindDevice: '绑定设备',
      deviceSerialNo: '设备序列号',
      deviceSerialNoPlaceholder: '请输入设备序列号/厂商设备号',
      driverType: '驱动类型',
      paperWidth: '纸张宽度',
      deviceStatus: '设备状态',
      onlineStatus: '在线状态',
      updateTime: '更新时间',
      remark: '备注',
      selectStore: '请选择门店',
      enterDeviceName: '请输入打印设备名称',
      nameTutorialLink: '点击查看获取设备名称教程',
      selectBelongStore: '请选择归属门店',
      selectBindDevice: '请选择绑定设备',
      enterDeviceSerialNo: '请输入设备序列号',
      selectDriverType: '请选择驱动类型',
      enterPaperWidth: '请输入纸张宽度',
      localEscPos: '本地ESC/POS',
      localTspl: '本地TSPL',
      localSystemDriver: '本地系统驱动',
      feieCloud: '飞鹅云',
      yilianCloud: '易联云',
      sunmiCloud: '商米云',
      enabled: '启用',
      disabled: '停用',
      online: '在线',
      offline: '离线',
      editSuccess: '编辑成功',
      addSuccess: '新增成功',
      deleteSuccess: '删除成功',
      deleteConfirmTitle: '删除确认',
      deleteConfirm: '确定要删除打印设备「{name}」吗？',
      statusConfirmTitle: '{action}确认',
      statusConfirm: '确定要{action}打印设备「{name}」吗？',
      statusSuccess: '{action}成功',
    },

    rules: {
      headRuleLibrary: '总部规则库',
      shopPrintRules: '门店打印规则',
      newRule: '新建规则',
      editRule: '编辑规则',
      ruleName: '规则名称',
      keywordPlaceholder: '规则名称 / 适用来源',
      systemDefault: '系统默认',
      copy: '复制',
      issue: '下发',
      noRules: '暂无打印规则',
      loading: '加载中...',
      noMore: '没有更多了',
      viewRules: '查看规则',
      basicInfo: '基础信息',
      printerType: '打印机类型',
      localPrinter: '本地打印机',
      cloudPrinter: '云打印机',
      allSourcePrint: '是否全部来源打印',
      yes: '是',
      no: '否',
      operationSource: '操作来源',
      printScene: '打印场景',
      ruleStatus: '规则状态',
      whetherEnabled: '是否启用',
      enabled: '已启用',
      enable: '启用',
      disabled: '停用',
      ruleDescription: '规则说明',
      enterRuleName: '请输入规则名称',
      selectPrinterType: '请选择打印机类型',
      selectAllSourcePrint: '请选择是否全部来源打印',
      selectOperationSource: '请选择操作来源',
      selectPrintScene: '请选择打印场景',
      enterRuleDescription: '请输入规则说明',
      issueStores: '下发门店',
      issueTip: '选择需要下发的门店，规则将同步到选中的门店中',
      selectedStores: '已选择 {count} 家门店',
      confirmIssue: '确认下发',
      viewRule: '查看规则',
      storePrint: '门店打印',
      storeCode: '门店编号',
      storeName: '门店名称',
      storeAddress: '门店地址',
      contact: '联系人',
      contactPhone: '联系电话',
      printCount: '打印 {count} 张',
      noPrint: '不打印',
      allSources: '全部来源',
      specifiedSources: '指定来源',
      listSeparator: '、',
      unnamedRule: '未命名规则',
      currentStore: '当前门店',
      copyName: '{name}副本',
      saveSuccess: '保存成功',
      addSuccess: '新增成功',
      deleteConfirmTitle: '删除确认',
      deleteConfirm: '确定要删除打印规则「{name}」吗？',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败，请稍后重试',
      selectIssueStore: '请选择下发门店',
      issueSuccess: '下发成功',
    },
  },
};
